module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "header": _vm.showModalTitle,
      "customClass": 'heightAuto',
      "footer": _vm.showFooter
    }
  }, [(_vm.showModalTitle) ? _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.modalTitle))])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c(_vm.getModalComponent, {
    tag: "div"
  })], 1), _vm._v(" "), (_vm.modalFooterType == 'cancelSave') ? _c('div', {
    staticClass: "d-flex flex-all",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickFooterCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving
    },
    on: {
      "click": _vm.clickFooterSave
    }
  }, [_vm._v("Save")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a91eca0e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ComponentModal.vue
// module id = 1305
// module chunks = 0